import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext({ settings: null, loading: true });

const FALLBACK_CONTENT = {
  "hero.eyebrow": "Hello, Amazing Teacher!",
  "hero.title": "Affordable Classroom Essentials for Caribbean Teachers",
  "hero.subtitle": "Made fun for Caribbean schools. Shop charts, decor, and supplies for every grade & subject.",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch {
      setSettings({ content: FALLBACK_CONTENT, shipping_options: [], exchange_rate: 160 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const t = (key, fallback = "") => settings?.content?.[key] ?? fallback;
  const img = (key) => settings?.category_images?.[key] || "";
  const exchangeRate = settings?.exchange_rate || 160;

  return (
    <SettingsContext.Provider value={{ settings, loading, t, img, exchangeRate, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
